import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AppService} from "@irb/app.service";
import {PageService} from "@irb-common/services/page.service";
import {Router} from "@angular/router";
import {AnalyticsService} from "@irb-common/analytics/analytics.service";
import {IrbDashboardService} from "@irb/irb-dashboard/irb-dashboard.service";
import {UtilityService} from "@irb-common/services/utility.service";
import { IApplyFilterOnLanding } from '@irb/app.model';
import {IAutoRebalancePortfolioData, IAutoRebalanceOrderData} from '@irb/irb-dashboard/irb-dashboard.service';
import {IGlobalSettings} from "@irb/irb-dashboard/irb-dashboard.model";
import {IrbSettingsEvents} from "@irb/irb-settings/irb-settings.events";
import {Subscription} from "rxjs";

@Component({
  standalone: false,
  selector: 'irb-module-auto-rebalancing-widget',
  templateUrl: './module-auto-rebalancing-widget.component.html',
  styleUrls: ['./module-auto-rebalancing-widget.component.scss']
})
export class ModuleAutoRebalancingWidgetComponent implements OnInit, OnDestroy {
  @Input() singleWidth: any;
  @Input() globalSettings: IGlobalSettings;
  @Input() customizableMode: boolean = false;
  
  autoRebalancePortfolioData: IAutoRebalancePortfolioData;
  autoRebalanceOrderData: IAutoRebalanceOrderData;
  timestamp: string;
  currentDate: string;
  nextDate: string;
  nullstate = false;
  isUserAutoRebalanceEnabled= false;
  selectedIndex: number = 0;
  private masterAccountSubscription: Subscription;
  selectedMasterAccounts: Array<string> = [];
  initailLoadPassed = false;
  dateFromTimestamp: string = '';
  timeFromTimestamp: string = '';
  showPortfolios: boolean = false;
  showOrders: boolean = false;
  selectedSection = 'portfolios';

  constructor(public as: AppService,
              public ps: PageService,
              private router: Router,
              private dbs: IrbDashboardService,
              private util: UtilityService,
              private ats: AnalyticsService) {
    this.timestamp = '';
  }

  ngOnInit(): void {
    if (this.customizableMode)
      return;

    this.showPortfolios = this.singleWidth ? true : false;
    this.masterAccountSubscription = this.dbs.currentMasterAccountData.subscribe(passedSelectedMasterAccounts => {
      if (this.initailLoadPassed) {
        this.autoRebalancePortfolioData = null;
        this.autoRebalanceOrderData = null;
        this.selectedMasterAccounts = passedSelectedMasterAccounts;
        if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
          this.getAutoRebalancePortfolioDataForSelectedAccounts();
        else
          this.getAutoRebalancePortfolioDataForAllAccounts();
      }
    });
    this.initailLoadPassed = true;
    this.getAutoRebalanceData();
  }

  getAutoRebalanceData() {
    this.autoRebalancePortfolioData = null;
    this.autoRebalanceOrderData = null;
    
    const currentDate = new Date();
    this.currentDate = currentDate.toLocaleString('en-US', {timeZone: 'America/New_York', year: 'numeric', month: '2-digit', day: '2-digit'});
    let d = this.util.getEasternTime(new Date().getTime());
    this.timestamp = this.util.formatDateTimeString(new Date(d), "MM/dd/yyyy hh:mm tt") + ' ET';
    this.dateFromTimestamp = this.timestamp.split(' ')[0];
    this.timeFromTimestamp = this.timestamp.substring(11);
    this.ps.getUserDetails().subscribe((d: any) => {
      if (d) {
        this.isUserAutoRebalanceEnabled = d.isAutomationEnabled;

        this.initailLoadPassed = true;
        this.selectedMasterAccounts = this.dbs.selectedMasterAccounts;
        if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
          this.getAutoRebalancePortfolioDataForSelectedAccounts();
        else
          this.getAutoRebalancePortfolioDataForAllAccounts();
      }
    });
  }

  getAutoRebalancePortfolioDataForAllAccounts() {
    this.dbs.getAutoRebalancePortfolioData().subscribe((response: any) => {
      this.autoRebalancePortfolioData = response || {};
      this.nullstate = !this.autoRebalancePortfolioData.autoRebalPfExist;
      //test data -----------------
      //  this.nullstate = false;
      //  this.autoRebalancePortfolioData.nextAutoRebalDate = '04/22/2026';
      //  this.autoRebalancePortfolioData.totalScheduledAutoRebalPfCount = 5;
      //  this.autoRebalancePortfolioData.autoRebalPfNoOrdersCount = 1;
      //  this.autoRebalancePortfolioData.autoRebalPfOrdersCount = 2;
      //  this.autoRebalancePortfolioData.autoRebalErrorCount = 3;
      //  this.autoRebalancePortfolioData.totalAutoRebalPfCount = 6;
      //--------------------------
      this.nextDate = this.autoRebalancePortfolioData.nextAutoRebalDate || '';
      this.autoRebalancePortfolioData.totalScheduledAutoRebalPfCount = this.autoRebalancePortfolioData.totalScheduledAutoRebalPfCount || 0;

      if(this.autoRebalancePortfolioData.totalAutoRebalPfCount > 0) {
        this.dbs.getAutoRebalanceOrderData().subscribe((response: any) => {
          this.autoRebalanceOrderData = response || {};
          //test data -----------------
          // this.autoRebalanceOrderData.approvedCount = 3;
          // this.autoRebalanceOrderData.errorCount = 1;
          // this.autoRebalanceOrderData.submitedCount = 2;
          // this.autoRebalanceOrderData.totalCount = 6;
          //---------------------------
        });
      } else {
        this.autoRebalanceOrderData = {} as IAutoRebalanceOrderData;
      }
    });
  }

  getAutoRebalancePortfolioDataForSelectedAccounts() {
    this.dbs.getAutoRebalancePortForMasters(this.selectedMasterAccounts).subscribe((response: any) => {
      this.autoRebalancePortfolioData = response || {};
      this.nullstate = !this.autoRebalancePortfolioData.autoRebalPfExist;
      this.nextDate = this.autoRebalancePortfolioData.nextAutoRebalDate || '';
      this.autoRebalancePortfolioData.totalScheduledAutoRebalPfCount = this.autoRebalancePortfolioData.totalScheduledAutoRebalPfCount || 0;

      if(this.autoRebalancePortfolioData.totalAutoRebalPfCount > 0) {
        this.dbs.getAutoRebalanceBlotterForMasters(this.selectedMasterAccounts).subscribe((response: any) => {
          this.autoRebalanceOrderData = response || {};
        });
      } else {
        this.autoRebalanceOrderData = {} as IAutoRebalanceOrderData;
      }
    });
  }

  goToPortfolios() {
    this.ats.trackPassiveEvent("lc_ports");
    this.router.navigate(['/clients/portfolios']);
  }

  refreshWidgetData() {
    this.getAutoRebalanceData();
  }
  
  showAutoRebalPfErrors() {
    let state = {
      isUpdatRequired: true,
      filterModels: [
        { name: 'rebalStatus', value: ['Rebalance Error','Trade Error','Order error'], isUpdatRequired: true },
        { name: 'lastRebalDate', value: {dateFrom: this.getToday(), dateTo: this.getToday()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      state.filterModels.push({name: 'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired: true});

    this.router.navigateByUrl('/reports/auto-rebalance-report', { state: state });
  }
  
  showAutoRebalPfOrders() {
    let state = {
      isUpdatRequired: true,
      filterModels: [
        { name: 'rebalStatus', value: ['Rebalance with Orders'], isUpdatRequired: true },
        { name: 'lastRebalDate', value: {dateFrom: this.getToday(), dateTo: this.getToday()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      state.filterModels.push({name: 'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired: true});

    this.router.navigateByUrl('/reports/auto-rebalance-report', { state: state });
  }

  showAutoRebalPfNoOrders() {
    let state = {
      isUpdatRequired: true,
      filterModels: [
        { name: 'rebalStatus', value: ['Rebalance without Orders'], isUpdatRequired: true },
        { name: 'lastRebalDate', value: {dateFrom: this.getToday(), dateTo: this.getToday()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      state.filterModels.push({name: 'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired: true});

    this.router.navigateByUrl('/reports/auto-rebalance-report', { state: state });
  }

  showAutoRebalPending() {
    const state = {
      isUpdatRequired: false,
      tabname:'Automated'
    } as IApplyFilterOnLanding;
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      state.filterModels = [{name: 'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired: true}];

    this.router.navigateByUrl('/orders/order-blotter', { state: state });
  }
  
  showAutoRebalError() {
    const d = new Date(this.util.getEasternTime(new Date().getTime()));
    let today = this.util.formatDateTimeString(d, "yyyy-MM-dd");

    let state = {
      isUpdatRequired: true,
      tabname:'Closed',
      filterModels: [
        { name: 'orderStatus', value: ["Canceled"], isUpdatRequired: true },
        { name: 'ticketType', value: ["A"], isUpdatRequired: true },
        { name: 'modifiedDate', value: {dateFrom: today, dateTo: today}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      state.filterModels.push({name: 'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired: true});

    this.router.navigateByUrl('/orders/order-blotter', { state: state });
  }
  showAutoRebalPfScheduled() {
    let state = {
      isUpdatRequired: true,
      filterModels: [
        { name: 'nextRebalDate', value: {dateFrom: this.getNextDate(), dateTo: this.getNextDate()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;
    // state.filterModels.push({name: 'masterAccount', value: ['8000058'], isUpdatRequired: true});
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      state.filterModels.push({name: 'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired: true});

    this.router.navigateByUrl('/reports/auto-rebalance-report', { state: state });
  }
  showAutoRebal() {
    let state: IApplyFilterOnLanding = {
      isUpdatRequired: true,
      tabname:'Closed',
      filterModels: [
        { name: 'orderStatus', value: ["Submitted","Filled"], isUpdatRequired: true },
        { name: 'ticketType', value: ["A"], isUpdatRequired: true },
        { name: 'modifiedDate', value: {dateFrom: this.getToday(), dateTo: this.getToday()}, isUpdatRequired: true }
      ]
    } as IApplyFilterOnLanding;
    if (this.selectedMasterAccounts && this.selectedMasterAccounts.length > 0)
      state.filterModels.push({name: 'masterAccount', value: this.selectedMasterAccounts, isUpdatRequired: true});

    this.router.navigateByUrl('/orders/order-blotter', { state: state });
  }
  showGlobalSettingsDialog() {
    this.as.setToLocal("LAST_TAB_INDEX", 6);
    this.as.fireEvent(IrbSettingsEvents.SHOW);
  }
  getToday() {
    const d = new Date(this.util.getEasternTime(new Date().getTime()));
    return this.util.formatDateTimeString(d, "yyyy-MM-dd");
  }
  getNextDate() {
    const mm= this.nextDate.substring(0,2);
    const dd = this.nextDate.substring(3,5);
    const yyyy = this.nextDate.substring(6,10);
    return yyyy + '-' + mm + '-' + dd;
  }

  applySectionChange() {
    if (this.selectedSection === 'portfolios') {
      this.showOrders = false;
      this.showPortfolios = true;
    } else {
      this.showOrders = true;
      this.showPortfolios = false;
    }
  }

  ngOnDestroy() {
    if (this.masterAccountSubscription)
      this.masterAccountSubscription.unsubscribe();
  }
}
